export enum AppMasterContextCategory {
    DEPARTMENT = 'DEPT',
    DESIGNATION = 'DESGN',
    EMPLOYMENT_TYPE = 'EMP_TYPE',
    EXAM_TYPE = 'EXAM_TYPE'
}
